const CCOffice = () => (
	<>
		<path d="M9.99265 8.21082H8.68079V15.1449H9.99265V8.21082Z" fill="#BADDF4" />
		<path d="M9.00879 6.80525V5.63395L9.66472 5.21228V6.80525H9.00879Z" fill="#BADDF4" />
		<path d="M10.1332 7.08636H8.39966V8.02341H10.1332V7.08636Z" fill="#BADDF4" />
		<path d="M21.284 8.25769H20.1595V15.0981H21.284V8.25769Z" fill="#BADDF4" />
		<path d="M21.6119 7.08636H19.8784V8.02341H21.6119V7.08636Z" fill="#BADDF4" />
		<path d="M20.4407 6.85213V5.25916L21.1435 5.63397V6.85213H20.4407Z" fill="#BADDF4" />
		<path
			d="M15.0527 2.16694L6.94726 6.66474L6.43188 5.634L8.77449 4.32214L15.0058 0.808228L23.7203 5.634L23.1581 6.66474L15.0527 2.16694Z"
			fill="#BADDF4"
		/>
		<path d="M6.75987 8.02344H2.73059V12.0527H6.75987V8.02344Z" fill="#BADDF4" />
		<path d="M27.328 8.02344H23.2987V12.0527H27.328V8.02344Z" fill="#BADDF4" />
		<path
			d="M6.94731 7.83606H2.54321V12.2402H6.94731V7.83606ZM2.96488 9.757V8.21088H4.511V9.757H2.96488ZM2.96488 11.7248V10.1787H4.511V11.7248H2.96488ZM4.93267 9.757V8.21088H6.47879V9.757H4.93267ZM4.93267 11.7248V10.1787H6.47879V11.7248H4.93267Z"
			fill="#002D55"
		/>
		<path
			d="M21.3778 3.99417L15.0059 0.433411L8.63401 3.99417H0.341187V15.0981H8.30605V15.5666H10.3675V15.0981H19.6911V15.5666H21.7526V15.0981H29.7175V3.99417H21.3778ZM17.4891 14.489H15.3807H17.4891ZM21.1435 8.49198V14.9107H20.3002V8.49198H21.1435ZM9.75846 8.49198V14.9107H8.91512V8.49198H9.75846ZM12.2416 14.489H10.3207V8.49198H10.5549V6.57104H10.0396V5.30603L15.0528 2.4949L20.0659 5.30603V6.57104H19.5506V8.49198H19.738V14.489H17.9576M9.89902 7.22697V7.8829H8.68086V7.22697H9.89902ZM5.82289 5.54029L6.71308 7.08641L8.54031 6.10252V6.57104H8.07179V8.49198H8.25919V14.489H0.950264V4.60325H7.55641L5.82289 5.54029ZM9.14939 6.57104V5.77455L9.38365 5.634V6.57104H9.14939ZM6.75993 5.8214L8.86827 4.60325L15.0059 1.18304L23.3456 5.8214L23.0645 6.33678L15.0996 1.83897L7.08789 6.33678L6.80678 5.8214H6.75993ZM20.1128 7.8829V7.22697H21.3309V7.8829H20.1128ZM20.6282 6.57104V5.634L20.8624 5.77455V6.57104H20.6282ZM21.4715 6.57104V6.10252L23.2987 7.08641L24.1889 5.54029L22.4554 4.5564H29.1084V14.489H21.7526V8.49198H21.94V6.57104H21.4715ZM14.9122 14.489H12.8039H14.9122Z"
			fill="#002D55"
		/>
		<path
			d="M27.5154 7.83606H23.1113V12.2402H27.5154V7.83606ZM23.533 9.757V8.21088H25.0791V9.757H23.533ZM23.533 11.7248V10.1787H25.0791V11.7248H23.533ZM25.5476 9.757V8.21088H27.0938V9.757H25.5476ZM25.5476 11.7248V10.1787H27.0938V11.7248H25.5476Z"
			fill="#002D55"
		/>
		<path
			d="M17.8638 14.5359V8.0703L17.7232 7.97659C15.8491 7.22696 14.0219 7.22696 12.2884 7.97659L12.1478 8.0703V14.5359"
			fill="#002D55"
		/>
		<path
			d="M14.8184 7.8829V14.5359H12.7101V8.35143C13.3192 8.07031 14.0219 7.92976 14.8184 7.8829Z"
			fill="#BADDF4"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.7877 11.5842C13.7877 11.4548 13.8926 11.3499 14.022 11.3499H14.3499C14.4793 11.3499 14.5842 11.4548 14.5842 11.5842C14.5842 11.7136 14.4793 11.8185 14.3499 11.8185H14.022C13.8926 11.8185 13.7877 11.7136 13.7877 11.5842Z"
			fill="#193D6E"
		/>
		<path
			d="M15.2401 7.8829V14.5359H17.3485V8.35143C16.7394 8.07031 16.0366 7.92976 15.2401 7.8829Z"
			fill="#BADDF4"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.4744 11.5842C15.4744 11.4548 15.5792 11.3499 15.7086 11.3499H16.0366C16.166 11.3499 16.2709 11.4548 16.2709 11.5842C16.2709 11.7136 16.166 11.8185 16.0366 11.8185H15.7086C15.5792 11.8185 15.4744 11.7136 15.4744 11.5842Z"
			fill="#193D6E"
		/>
	</>
);

export default CCOffice;
